"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ChevronDown = function ChevronDown(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 20 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 20 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "#000" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 10 6",
    scale: width / 10,
    width: width,
    height: height,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5 3.515L8.694 0 10 1.243 5 6 0 1.243 1.306 0z",
    id: "chevronDown"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    fillRule: "nonzero",
    xlinkHref: "#chevronDown"
  }));
};

var _default = ChevronDown;
exports["default"] = _default;
module.exports = exports["default"];